import React, { useEffect } from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { useLocation } from 'react-router-dom';

import { ThemeClient } from '../contexts/Theme';
import { useThemeClientLogo } from '../contexts/Theme.js';
import { host } from '../supabaseClient.js';
import { useCompany } from '../contexts/Company';

// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    image: {
        width: '100%',
        height: '100%'
    },
    logo:{
        position: 'absolute',
        left: '-100px',
        top: '200px',
        width: '400px',
        transform: 'rotate(90deg)',
        fontSize: '70px'
    },
    clientName: {
        position: 'absolute',
        left: '270px',
        top: '230px',
        width: '200px',
        transform: 'rotate(90deg)',
        fontSize: '70px'
    }
});

const Certificate = ({ }) => {
    const location = useLocation();

    const company = useCompany()
    //const { logo } = useThemeClientLogo();

    const searchParams = new URLSearchParams(location.search);
    const name = searchParams.get('name');
    const date = searchParams.get('date');

    useEffect(() => {
        setTimeout(() => {
            window.print()
        }, 4000);               
    }, []);

    return (
        <ThemeClient>
            <Document>
                <style>
                    {`@page {margin: 0}`}
                </style>
                <Page size="A4" style={styles.page}>
                    <p style={styles.clientName}>{name}</p>
                    {/* <p style={styles.clientLogo}>{date}</p> */}
                    {/* <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/NTT-Data-Logo.svg/2560px-NTT-Data-Logo.svg.png" style={styles.clientLogo}></img> */}
                    
                    <img src="https://i.imgur.com/EFHBIyw.png" style={styles.image} />
                    <img width={'100px'} src={host + '/storage/v1/object/public/logos/' + company?.id + '.png'} style={styles.logo}></img> 
                </Page>
            </Document>
        </ThemeClient>
    );
};
export default Certificate;
